/**
 * List of constants required for ensighten tagging, we will be using on page level components to update jcpDl object
 */
const constants = {
    PDP_PAGE_ID: 'pdp',
    MINI_PDP_PAGE_ID: 'mini pdp',
};

export default constants;
